import {
  useNavigate,
  useLocation,
  useParams,
  useNavigationType,
  useSearchParams,
} from "react-router-dom";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const params = useParams();
    const queryParams = Object.fromEntries(
      new URLSearchParams(searchParams.toString())
    );
    const updateQuery = (key, value, callback) => {
      const currentValue = searchParams.get(key);
      if (currentValue !== value) {
        const updatedSearchParams = new URLSearchParams(searchParams);
        updatedSearchParams.set(key, value);
        setSearchParams(updatedSearchParams);
        
        // Immediate callback to bypass React Router delays
        if (callback) {
          const newQuery = Object.fromEntries(updatedSearchParams);
          setTimeout(() => callback(newQuery), 0);
        }
      }
    };

    const updateMultipleQueries = (queries, callback) => {
      let hasChanged = false;
      const updatedSearchParams = new URLSearchParams(searchParams);

      Object.entries(queries).forEach(([key, value]) => {
        if (updatedSearchParams.get(key) !== value) {
          updatedSearchParams.set(key, value);
          hasChanged = true;
        }
      });

      if (hasChanged) {
        setSearchParams(updatedSearchParams);
        
        // Immediate callback to bypass React Router delays
        if (callback) {
          const newQuery = Object.fromEntries(updatedSearchParams);
          setTimeout(() => callback(newQuery), 0);
        }
      }
    };
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        query={queryParams}
        navigationType={navigationType}
        updateQuery={updateQuery}
        updateMultipleQueries={updateMultipleQueries}
        setSearchParams={setSearchParams}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
